import { render, staticRenderFns } from "./CompositeTableColumn.vue?vue&type=template&id=5ecbe95e"
import script from "./CompositeTableColumn.vue?vue&type=script&lang=js"
export * from "./CompositeTableColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports